import { bigQuery } from '@fiverr-private/obs';
import { GrafanaEvents } from '../../utils/events/grafana/events';
import { BigQueryEvents } from '../../utils/events/bigQuery';
import { MixpanelEvents } from '../../utils/events/mixpanel/events';
import { sendMixpanel } from '../../utils/events/mixpanel';
import { sendGraph } from '../../utils/events/grafana';

export const ReportingChannelType = {
    GRAFANA: {
        name: 'grafana',
        events: GrafanaEvents,
        reporter: sendGraph
    },
    BIG_QUERY: {
        name: 'bigQuery',
        events: BigQueryEvents,
        reporter: bigQuery.send
    },
    MIXPANEL: {
        name: 'mixpanel',
        events: MixpanelEvents,
        reporter: sendMixpanel
    }
};
